import React, { Component } from "react";
import {Modal} from "antd";
import CheckIcon from "../../assets/icons/check-icon.svg";
import "./CloseWindowModal.css";

export class CloseWindowModal extends Component {

    render(){
        const {
            showCloseWindowModal,
            title = "Lo estamos redireccionando a la ventana de pagos"
        } = this.props;

        return (
            <React.Fragment>
                <Modal
                    visible = {showCloseWindowModal}
                    onCancel={() => {}}
                    width={540}
                    footer={null}
                    centered
                >
                    <div className="c-w-container">
                        <img className="c-w-img" src={CheckIcon} alt="check" />
                        <p className="c-w-p">
                            {title}
                        </p>
                    </div>
                </Modal>
            </React.Fragment>
        )
    }
}

export default CloseWindowModal;